import React from "react";
import { Routes, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useIsAuthenticated } from "@azure/msal-react";

// import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ListAllAWSAccounts from "./components/ListAllAWSAccounts";
import AddUser from "./components/AddUser";
import ManageUser from "./components/ManageUser";
import Forbidden from "./pages/Forbidden";

function AppRoutes() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <main className="my-2">
      <Container>
        <Routes>
          <Route
            path="/"
            element={isAuthenticated ? <ListAllAWSAccounts /> : <LoginPage />}
          />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/user/AWSAccounts"
            element={isAuthenticated ? <ListAllAWSAccounts /> : <LoginPage />}
          />
          <Route
            path="/admin/new/user"
            element={isAuthenticated ? <AddUser /> : <LoginPage />}
          />
          <Route
            path="/admin/manage/users"
            element={isAuthenticated ? <ManageUser /> : <LoginPage />}
          />
           <Route path="/403" 
          element={<Forbidden />} />
        </Routes>
       
      </Container>
    </main>
  );
}

export default AppRoutes;
